__webpack_require__.p = "/dev/karaoke-handle-shift-click/";